import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import ConstituentPropType from '@/lib/types/ConstituentPropType';
import {
  getPrimaryEmail,
  getPrimaryPhoneNumber,
} from '@/utils/constituentUtils';
import { showSuccessMessage } from '@/utils/ToastFeedback';

const copy = async (text) => {
  await navigator.clipboard.writeText(text);
  showSuccessMessage({
    message: `${translate('COPIED')}: ${text}`,
  });
};

function ConstituentCommunicationMenu({
  constituent,
  isEmail,
  onClose,
  open,
  target,
}) {
  const email =
    constituent?.primaryEmail || getPrimaryEmail(constituent?.emails);
  const phone = getPrimaryPhoneNumber(constituent?.phones);
  const menuItems = [
    {
      label: translate(isEmail ? 'SEND_EMAIL' : 'CALL'),
      onClick: () => {
        window.location.href = isEmail ? `mailto:${email}` : `tel:${phone}`;
      },
    },
    {
      label: translate(isEmail ? 'COPY_ADDRESS' : 'COPY_NUMBER'),
      onClick: () => copy(isEmail ? email : phone),
    },
  ];

  return (
    constituent &&
    !!menuItems.length && (
      <Menu onClose={onClose} open={open} anchorEl={target}>
        {menuItems.map(({ label, onClick }) => (
          <MenuItem key={label} onClick={onClick}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    )
  );
}

ConstituentCommunicationMenu.propTypes = {
  constituent: ConstituentPropType,
  isEmail: PropTypes.bool,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  target: PropTypes.element,
};

ConstituentCommunicationMenu.defaultProps = {
  constituent: null,
  isEmail: false,
  onClose: () => {},
  open: false,
  target: null,
};

export default ConstituentCommunicationMenu;
